<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row>
        <v-col cols="5">
          <h3><v-icon class="mr-2">mdi-cash-sync</v-icon> Ultimos Pedidos Aprovados</h3>
        </v-col>
        <v-col cols="">
          <v-text-field
            v-model="search"
            justify="end"
            placeholder="Pesquisar"
            outlined
            dense
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="1" class="text-right">
          <v-btn color="green" dark depressed @click="send()">Enviar Email</v-btn>
        </v-col>
        <v-col class="text-right ms-5" cols="2">
          <v-btn 
            depressed 
            color="primary" 
            class="text-center mr-1" 
            :disabled="!orders.length"
            :dark="orders.length" 
            @click="downloadCSV()" 
            block
          >
            <v-icon small class="mx-2">mdi-magnify</v-icon>
            Exportar CSV
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="my-3"></v-divider>
      <v-data-table
        :items="orders"
        :loading="loading"
        :headers="headers"
        :search="search"
        v-model="selectedOrders"
        show-select
        item-key="orderIdMarketplace"
        :items-per-page="50"
      >
        <template v-slot:[`item.orderIdMarketplace`]="{ item }">
          {{ item.orderIdMarketplace }}

          <TheToolTip label="Link Hubble">
            <v-icon small class="ml-2" @click="loadContent(item.orderIdMarketplace)">
              mdi-link
            </v-icon>
          </TheToolTip>

          <TheToolTip label="Link Vtex">
            <v-icon small class="ml-2" @click="loadVtex(item.orderIdMarketplace)">
              mdi-shield-link-variant-outline
            </v-icon>
          </TheToolTip>
        </template>

        <template v-slot:[`item.clientFirstName`]="{ item }"
          >{{ item.clientFirstName }} {{ item.clientLastName }}</template
        >
        <template v-slot:[`item.orderStatus`]="{ item }" class="justify-center">
          <v-layout justify-center>
            <v-chip label :color="getColor(item.orderStatus)" dark>
              {{ item.orderStatusDescription }}
            </v-chip>
          </v-layout>
        </template>

        <template v-slot:[`item.orderSellerStatus`]="{ item }" class="justify-center">
          <v-layout justify-center>
            <v-chip label :color="getColor(item.orderSellerStatus)" dark>{{
              getStatusSeller(item.orderSellerStatus)
            }}</v-chip>
          </v-layout>
        </template>

        <template v-slot:[`item.orderCreationDate`]="{ item }">
          {{ item.orderCreationDate | formatFullDate }}
        </template>

        <template :v-if="item.orderValue" v-slot:[`item.orderValue`]="{ item }">{{
          item.orderValue | formatMoney
        }}</template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from '@/global'
import { getColor, getStatusSeller } from '@/plugins/generic.js'
import TheToolTip from '@/components/TheToolTip'

export default {
  components: {
    TheToolTip,
  },
  data: () => ({
    orders: [],
    headers: [
      { value: 'orderIdMarketplace', text: 'ID Order' },
      { value: 'sellerDescription', text: 'Seller' },
      { value: 'clientFirstName', text: 'Nome Cliente' },
      { value: 'orderSellerStatus', text: 'Status Seller', align: 'center' },
      { value: 'orderStatus', text: 'Status Vtex', align: 'center' },
      { value: 'orderCreationDate', text: 'Data', align: 'center' },
      { value: 'orderValue', text: 'Valor', align: 'center' },
      { value: 'paymentSystemName', text: 'Forma', align: 'center' },
    ],
    shopifyStatus: ['payment-pending', 'ready-for-handling', 'canceled'],
    shopifyStatusFiltered: [],
    loading: false,
    search: null,
    colors: [
      { status: 'paid', color: 'green' },
      { status: 'pending', color: 'blue-grey lighten-5' },
      { status: 'payment-pending', color: 'cyan lighten-5' },
      { status: 'ready-for-handling', color: 'lime accent-3' },
      { status: 'canceled', color: 'deep-orange darken-' },
      { status: 'handling', color: 'green accent-4' },
      { status: 'restocked', color: 'deep-orange lighten-2' },
      { status: 'dispatched', color: 'deep-orange lighten-3' },
      { status: 'fulfilled', color: 'deep-orange lighten-4' },
      { status: 'complete', color: 'blue' },
      { status: 'delivered', color: 'blue' },
    ],
    selectedOrders: [],
    // Dois dias laranjas, passou do dia vermelho
  }),
  computed: {},
  methods: {
    getColor,
    getStatusSeller,
    async loadData() {
      this.loading = true
      const url = `${baseApiUrl}/order`
      this.orders = await axios
        .get(url)
        .then((res) => {
          return res.data.filter((el) => {
            return (
              el.orderSellerStatus === 4 &&
              (el.sellerDescription === 'FRESNOMAQ' || el.sellerDescription === 'FRESNOMAQFILIAL')
            )
          })
        })
        .catch((err) => {
          console.log(err.message)
          return []
        })

      this.loading = false
    },
    loadContent(order) {
      let route = this.$router.resolve({
        name: 'Order',
        params: { id: order },
      })
      window.open(route.href, '_blank')
    },
    loadVtex(order) {
      window.open(` https://lojawap.myvtex.com/admin/checkout/#/orders/${order}`, '_blank')
    },
    async send() {
      const object = this.selectedOrders.map((el) => {
        return el.orderIdMarketplace
      })

      const url = `${baseApiUrl}/order/email`
      await axios
        .post(url, object)
        .then(() => {
          alert('Email enviado com Sucesso')
        })
        .catch((err) => {
          console.log(err.message)
          return []
        })
    },
    downloadCSV() {
      const data = this.orders
      const fileName = 'Ultimos-pedidos-aprovados'
      const csv = this.convertArrayOfObjectsToCSV(data)
      const link = document.createElement('a')
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      link.download = fileName + '.csv'
      link.click()
    },
    convertArrayOfObjectsToCSV(data) {
      const columnDelimiter = ','
      const lineDelimiter = '\n'
      const keys = Object.keys(data[0])

      let result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach((item) => {
        let ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },
  },
  async mounted() {
    await this.loadData()
  },
}
</script>

<style></style>
